// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1PnYw"};